import { HttpClient } from './HttpClient';
import { getAuthRoot, getViewerRoot, tryGetPacsRoot } from '../config/roots';
import { readCookie } from '../utils';

export { HttpClient } from './HttpClient';
export { HttpException, UnauthorizedException } from './exceptions';
export type { RequestOptions, HttpResponse, HttpClientProviders } from './HttpClient';

let onViewerUnauthorized: (() => void) | null = null;

export function setViewerUnauthorizedHandler(handler: () => void): void {
  onViewerUnauthorized = handler;
}

export const authHttp = new HttpClient({
  getBaseUrl: getAuthRoot,
  getAuthHeader: () => {
    const accessToken = readCookie('accessToken');
    return accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;
  },
});

export const viewerHttp = new HttpClient({
  getBaseUrl: getViewerRoot,
  getAuthHeader: () => {
    const accessToken = readCookie('accessToken');
    return accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;
  },
  onUnauthorized: () => onViewerUnauthorized?.(),
});

export const orthancHttp = new HttpClient({
  getBaseUrl: tryGetPacsRoot,
  getAuthHeader: () => {
    const accessToken = readCookie('accessToken');
    return accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;
  },
});
